import Topbar from '@eduzz/ui-layout/Topbar';
import Tooltip from '@material-ui/core/Tooltip';
import { NewReleases } from '@material-ui/icons';
import { Divider, Menu } from '@mui/material';
import React, { useState } from 'react';
import { useObservable } from 'react-use-observable';
import { BRANCH_NAME, BUILD_DATE, BUILD_NUMBER, ENV, IS_PROD, VERTICAL_URL } from 'settings';
import apiService from 'v2/services/api';

import { Details } from './Details';

type ApiVersion = {
  branchName: string;
  environment: string;
  version: number;
  versionDate: string;
};

export default () => {
  const [apiVersion] = useObservable(() => apiService.get<ApiVersion>('/version'), []);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClose = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleClick = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  if (IS_PROD || apiVersion === null) return null;

  const isOpen = Boolean(anchorEl);

  return (
    <>
      <Tooltip title='Ambiente' placement='bottom'>
        <span>
          <Topbar.Action
            id='topbar-action-env'
            aria-label='mostrar config. ambiente'
            onClick={handleClick}
            icon={<NewReleases color='secondary' />}
          />
        </span>
      </Tooltip>

      <Menu
        id='env-menu'
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        MenuListProps={{
          'aria-labelledby': 'topbar-action-env',
        }}
      >
        <Details
          name='myeduzz-front'
          env={ENV}
          branch={`${BRANCH_NAME} ${BUILD_NUMBER}`}
          date={BUILD_DATE}
          redirect={`https://github.com/eduzz/myeduzz-front/tree/${BRANCH_NAME}`}
        />
        <Divider />
        <Details
          name='myeduzz-api'
          env={apiVersion.environment}
          branch={apiVersion.branchName}
          date={apiVersion.versionDate}
          redirect={`https://github.com/eduzz/myeduzz-front/tree/${apiVersion.branchName}`}
        />
        <Divider />
        <Details name='myeduzz-vertical' env={'verificar'} branch={VERTICAL_URL} date={''} redirect={'https://github.com/eduzz/myeduzz-vertical'} />
      </Menu>
    </>
  );
};
